export class AlertDialogProps {
  constructor(content, title) {
    this.content = content;
    this.title = title;
  }
}
